module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner",
    style: (_vm.styles)
  }, [_c('div', {
    staticClass: "blob top",
    style: (_vm.blobStyles)
  }), _vm._v(" "), _c('div', {
    staticClass: "blob bottom",
    style: (_vm.blobStyles)
  }), _vm._v(" "), _c('div', {
    staticClass: "blob left",
    style: (_vm.blobStyles)
  }), _vm._v(" "), _c('div', {
    staticClass: "blob move-blob",
    style: (_vm.moveBlobStyles)
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1613d234","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-loading-spinner/src/components/ThreeDots.vue
// module id = 618
// module chunks = 1